import React from 'react';
import {
    IconButton,
    DialogTitle as MuiDialogTitle,
    Typography
} from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { space, fontSize, fontWeight, color } from './tokens';

interface Props {
    children: React.ReactNode;
    onClose?: () => void;
    id?: string;
}

const titleRowStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: space.md,
    paddingBottom: space.sm,
    paddingLeft: space.lg,
    paddingRight: space.sm
};

const titleTextStyle: React.CSSProperties = {
    fontSize: fontSize.title,
    fontWeight: fontWeight.bold,
    color: color.text.primary,
    lineHeight: '24px',
    flex: 1,
    paddingRight: space.md
};

const closeButtonStyle: React.CSSProperties = {
    color: color.text.muted,
    padding: space.sm
};

export const HarmonisedDialogTitle: React.FC<Props> = ({
    children,
    onClose,
    id = 'harmonised-dialog-title'
}) => {
    return (
        <MuiDialogTitle
            disableTypography
            id={id}
            style={{ padding: 0 }}
        >
            <div style={titleRowStyle}>
                <Typography component="div" style={titleTextStyle}>
                    {children}
                </Typography>
                {onClose ? (
                    <IconButton
                        aria-label="close"
                        size="small"
                        onClick={onClose}
                        style={closeButtonStyle}
                    >
                        <Close fontSize="small" />
                    </IconButton>
                ) : null}
            </div>
        </MuiDialogTitle>
    );
};

export default HarmonisedDialogTitle;
